<template>
  <v-container fluid fill-width class="container-full-bg-gray">
    <div>
    <app-modal-prompt
      v-if="screen_data.general_error_dialog"
      v-model="screen_data.general_error_dialog"
      :showConfirmBtn="false"
      @cancel="screen_data.general_error_dialog=false"
    >
      <template #title>
        Error en la subida de ficheros
      </template>
      <template>
        <app-modal-container>
          <app-confirm-modal-title 
            show-title
            :text-title="screen_data.general_error_text"
            class="mb-8"
          />
        </app-modal-container>
      </template>
    </app-modal-prompt>
    <app-modal-prompt 
      v-model="screen_data.error_dialog"
      @cancel="screen_data.error_dialog=false"
      @confirm="retryUploadFiles()"
    >
      <template #title>
        Error de subida de ficheros
      </template>
      <template>
        <app-modal-container>
          <app-confirm-modal-title 
            show-title
            :text-title="screen_data.confirm_title"
            class="mb-8"
          />
          <app-modal-row justify="center">
            <app-modal-col cols="8">
              <ul>
                <div v-for="file_name in Object.keys(screen_data.uploaded_files)" :key="file_name">
                  <li v-if="!screen_data.uploaded_files[file_name]" class="document-loader__list-element">
                    {{file_name}}
                  </li>
                </div>
              </ul>
            </app-modal-col>
          </app-modal-row>
        </app-modal-container>
      </template>
      <template #confirm-button-name>
        Reintentar
      </template>
    </app-modal-prompt>
     <photo-loading-dialog 
      :dialog.sync="photoDialog"
      @close-dialog="closePhotoDialog"
      @assign-photo="setPhotoForCertifiedInvoice"
    />
    <app-confirm-modal
      v-model="screen_data.error_dialog_ext"
      text-center-msg
      show-title
      show-confirm-button
      text-title="Se ha intentado subir un fichero con un formato que no soportamos"
      text-confirm-button="Aceptar"
      :text-msg="wrongFormatMsg"
      :show-text-question="false"
      :show-cancel-button="false"
      @confirm="screen_data.error_dialog_ext = false"
    />
    <app-page-card 
      :class="{dragging_file:dragging_file, 'rounded-xl': true}" 
      :color="dragging_file ? 'var(--v-neutralDark-base)' : ''"
      @drop="dropFiles"
      @dragover="dragging_file=true" 
      @dragleave="dragging_file=false"     
    >
      <template #header>
        Subir documentos
      </template>
    <v-tabs :hide-slider="!showCertificate" :fixed-tabs="showCertificate" :height="squareHeight">
          <v-tab key="0" >{{main_tab_text}}</v-tab>
          <v-tab v-if="showCertificate" key="1" >Factura certificada</v-tab>
          <v-tab-item key="0">
            <template>
            <app-header-with-subtitle>
                <template #icon>
                  mdi-file-upload-outline
                </template>
                <template>
                  Desde aquí puedes subir todos tus documentos
                </template>
                <template #subtitle>
                  Puede ser en formato pdf/jpg/png o desde un fichero zip/rar/7z que contenga varios archivos
                </template>
            </app-header-with-subtitle>
            <app-row justify="center">
              <app-col cols="12" md="8" lg="6">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <app-row>
                    <app-col contains-input-fields cols="12">
                      <v-file-input
                        v-model="screen_data.files"
                        multiple
                        outlined
                        prepend-icon=""
                        name="uploader"
                        accept=".pdf, .jpg, .png, .zip, .rar, .7z, .tiff, .docx, .doc, .odt, .xls, .xlsx, .xlsm, .ods,.xml,.xsig"
                        label="Arrastre aquí sus ficheros o haga click para seleccionar ficheros desde carpeta"
                        class="file-input--outlined rounded-lg"
                        :disabled="screen_data.uploading"
                        :error="!screen_data.uploading && screen_data.uploaded_files && Boolean(Object.keys(screen_data.uploaded_files).length)"
                        @change="removeDuplicates"
                      >
                        <template #prepend-inner>
                          <v-icon color="primary" left>
                            mdi-paperclip
                          </v-icon>
                        </template>
                        <template #append>
                          <v-icon
                            color="error"
                            v-if="!screen_data.uploading && screen_data.uploaded_files && Boolean(Object.keys(screen_data.uploaded_files).length)"
                            @click="screen_data.error_dialog=!screen_data.error_dialog"
                          >
                            mdi-alert
                          </v-icon>
                        </template>
                      </v-file-input>
                    </app-col>
                  </app-row>
                  <v-row v-if="screen_data.uploading && screen_data.uploading_file">
                    <v-col cols="12" md="2" v-if="screen_data.uploading && screen_data.uploading_file" class="pa-1">
                      <p class="title-color">{{ screen_data.uploading_file }}:</p>
                    </v-col>
                    <v-col cols="12" :md="Boolean(screen_data.uploading_file)?'10':'12'" class="pa-1">
                      <v-progress-linear
                        :active="screen_data.uploading"
                        :value="uploading_percent2"
                        color="primary"
                        height="25"
                        striped
                        readonly
                      >
                        <template v-slot:default="{ value }">
                          <strong>{{ Math.ceil(value) }} %</strong>
                        </template>
                      </v-progress-linear>
                    </v-col>
                    <v-col cols="12" class="pa-1 ma-1">
                      <v-progress-linear
                        :active="screen_data.uploading && screen_data.files.length > 1"
                        :value="screen_data.uploading_percent"
                        color="primary"
                        height="25"
                        striped
                        readonly
                      >
                        <template v-slot:default="{ value }">
                          <strong>{{ Math.ceil(value) }} %</strong>
                        </template>
                      </v-progress-linear>
                    </v-col>
                  </v-row>
                  <app-row>
                    <app-col contains-input-fields has-input-fields-above cols="12" sm="6" md="4">
                      <app-select v-model="screen_data.kind" label="Tipo de documento" item-value="id" item-text="text" 
                        :error="screen_data.empty_kind"
                        :items="availableDocs"
                        name="selectorTipoDoc"
                      />
                    </app-col>
                    <app-col contains-input-fields has-input-fields-above cols="12" sm="6" md="4">
                      <app-select v-model="screen_data.accounting_date_config"  label="Fecha contable" item-value="id" item-text="text" 
                        :items="ACCOUNTING_DATE_OPTIONS"
                        name="selectorFecha"
                      />
                    </app-col>
                    <app-col contains-input-fields has-input-fields-above cols="12" sm="6" md="4" v-if="got_feature('feature_fecha_registro') && currentCompany && currentCompany.enable_fecha_sii">
                      <app-select v-model="screen_data.registro_date_config" label="Fecha SII" item-value="id" item-text="text"
                        :items="REGISTRO_DATE_OPTIONS"
                      />
                    </app-col>
                  </app-row>
                  <app-row
                    v-if="screen_data.accounting_date_config === 'configurated' || got_feature('feature_fecha_registro') && currentCompany && currentCompany.enable_fecha_sii && screen_data.registro_date_config=='configurated'"
                    justify="end"
                  >
                    <app-col contains-input-fields has-input-fields-above cols="12" sm="6" md="4">
                      <app-text-field 
                        v-if="screen_data.accounting_date_config === 'configurated'"
                        v-model="screen_data.default_accounting_date"
                        label="Fecha contable (dd/mm/YYYY)" 
                        :error="screen_data.invalid_default_accounting_date"
                      />
                    </app-col>
                    <app-col contains-input-fields has-input-fields-above cols="12" sm="6" md="4">
                      <app-text-field
                        v-if="got_feature('feature_fecha_registro') && currentCompany && currentCompany.enable_fecha_sii && screen_data.registro_date_config=='configurated'"
                        v-model="screen_data.default_registro_date"
                        label="Fecha de registro (dd/mm/YYYY)"
                        :error="screen_data.invalid_default_registro_date"
                      />
                    </app-col>
                  </app-row>
                  <app-row align="baseline">
                    <app-col cols="12" sm="6" md="3" v-if="excelFileChosen && got_feature('feature_upload_office')">
                      <app-select v-model="screen_data.excel_kind" class="mx-2" label="Tipo de excel" 
                        item-value="id" item-text="text" 
                        :items="[{id:'excel_list',text:'Listado'},{id:'excel_image',text:'Imagen'}]"
                        name="selectorTipoExcel"
                      ></app-select>
                    </app-col>
                    <app-col contains-input-fields has-input-fields-above cols="6" sm="4" md="3" v-else>
                      <v-checkbox hide-details v-model="split" class="my-0"  label="Separar páginas"></v-checkbox>
                    </app-col>
                    <app-col contains-input-fields has-input-fields-above v-if="userData.is_staff" cols="6" sm="4" md="3">
                      <app-select v-model="selected_tags"  label="Tags" :items="tags" multiple item-text="name" item-value="value" />
                    </app-col>
                    <app-col contains-input-fields has-input-fields-above v-if="hasActivityPermissionUser && got_feature('feature_actividad_selector') && activities.length > 0" cols="6" sm="4" md="3">
                      <app-autocomplete
                        id="actividad-autocomplete"
                        label="Actividad"
                        v-model="default_activity"
                        :items="activities"
                        :error="screen_data.empty_actividad"
                        item-value="code" item-text="name"
                        :clearable="true"
                      />
                    </app-col>
                    <app-col contains-input-fields has-input-fields-above v-else-if="hasActivityStrPermissionUser && got_feature('feature_actividad_selector') && activities.length > 0" cols="6" sm="4" md="3">
                      <app-autocomplete
                        id="actividad-autocomplete"
                        label="Actividad"
                        v-model="default_activity"
                        :items="activities"
                        :error="screen_data.empty_actividad"
                        item-value="code" item-text="name"
                        :clearable="true"
                      />
                    </app-col>
                    <app-col contains-input-fields has-input-fields-above v-else-if="hasActivityPermissionUser" cols="6" sm="4" md="3">
                      <app-text-field :error="screen_data.empty_actividad" v-model="default_activity" type="number" label="Actividad"/>
                    </app-col>
                    <app-col contains-input-fields has-input-fields-above v-if="projects && projects.length>0 && hasProjectPermissionUser" cols="6" sm="4" md="3">
                      <app-autocomplete
                        v-model="selected_project"
                        label="Proyecto"
                        :items="projects" 
                        :clearable="true"  
                        item-text="name" 
                        item-value="id"
                      />
                    </app-col>

                    <app-col contains-input-fields has-input-fields-above v-if="channels && channels.length>0 && hasChannelPermissionUser" cols="6" sm="4" md="3">
                      <app-autocomplete 
                        outlined
                        v-model="default_channel" 
                        label="Canal" 
                        :items="channels" 
                        :clearable="true"  
                        item-text="name" 
                        item-value="channel_id"
                      />
                    </app-col>

                    <app-col contains-input-fields has-input-fields-above v-if="sections && sections.length>0 && hasSectionPermissionUser" cols="6" sm="4" md="3">
                      <app-autocomplete
                        v-model="selected_section"
                        label="Sección"
                        :items="sections" 
                        :clearable="true"  
                        item-text="name" 
                        item-value="section_id"
                      />
                    </app-col>
                    <app-col contains-input-fields has-input-fields-above v-if="delegations && delegations.length>0 && hasDelegationPermissionUser" cols="6" sm="4" md="3">
                      <app-autocomplete
                        v-model="selected_delegation"
                        label="Delegación"
                        :items="delegations" 
                        :clearable="true"  
                        item-text="name" 
                        item-value="delegation_id"
                      />
                    </app-col>

                    <app-col contains-input-fields has-input-fields-above v-if="departments && departments.length>0 && hasDepartmentPermissionUser" cols="6" sm="4" md="3">
                      <app-autocomplete
                        v-model="selected_department"
                        label="Departamento"
                        :items="departments" 
                        :clearable="true"  
                        item-text="name" 
                        item-value="department_id"
                      />
                    </app-col>

                    <app-col contains-input-fields has-input-fields-above cols="6" sm="4" md="3" v-if="showCertificate && userData.is_staff">
                      <v-checkbox hide-details v-model="certificate" class="my-0"  label="Simular Certificado (dev)"></v-checkbox>
                    </app-col>
                  </app-row>
                  <app-row justify="center">
                    <app-col has-input-fields-above cols="12" sm="6" md="4">
                      <app-btn x-large 
                        name="subir" 
                        :disabled="!screen_data.files || !screen_data.kind" 
                        color="primary" 
                        @click="uploadFiles" 
                        :loading="screen_data.uploading"
                      >Subir documentos</app-btn>
                    </app-col>
                  </app-row>            
                </v-form>
              </app-col>
            </app-row>
            </template>
        </v-tab-item>
        <v-tab-item key="1">
          <v-card>
            <v-card-title v-if="!is_mobile" class="title title-color">
              Subir documento a partir de foto o escáner
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row align="center">
                  <v-col cols="12" sm="6" md="2" class="text-center">
                    <v-btn large @click="openPhotoDialog" >
                      <v-icon left>mdi-camera</v-icon>
                      Tomar foto
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12" sm="6" md="2" class="text-center">
                    <v-btn
                      name="subir" 
                      color="primary" 
                      :loading="screen_data.uploading"
                      :disabled="!certifiedInvoiceFormIsValid"
                      @click="certificateUpload"
                    >
                      Subir documentos
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-select
                      v-model="screen_data.kind"
                      name="selectorTipoDoc"
                      label="Tipo de documento"
                      class="mx-2"
                      item-value="id"
                      item-text="text" 
                      :class="{invalid:screen_data.empty_kind}"
                      :items="availableDocs"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-select
                      v-model="screen_data.accounting_date_config"
                      name="selectorFecha"
                      class="mx-2"
                      label="Fecha contable"
                      item-value="id"
                      item-text="text" 
                      :items="ACCOUNTING_DATE_OPTIONS"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-text-field 
                      v-if="screen_data.accounting_date_config=='configurated'" 
                      v-model="screen_data.default_accounting_date"
                      label="Fecha (dd/mm/YYYY)"
                      :class="{invalid:screen_data.invalid_default_accounting_date}"
                    />
                  </v-col>
                  <v-col v-if="userData.is_staff" cols="6" sm="4" md="2">
                    <v-select
                      v-model="selected_tags"
                      multiple
                      class="mx-2"
                      label="Tags"
                      item-text="name"
                      item-value="value"
                      :items="tags"
                    />
                  </v-col>
                  <v-col
                    v-if="!got_feature('feature_actividad_selector') && (hasActivityPermissionUser)" 
                    cols="6"
                    sm="4"
                    md="1"
                  >
                    <v-text-field
                      :class="{invalid:screen_data.empty_actividad}"
                      v-model="default_activity"
                      class="mx-2"
                      type="number"
                      label="Actividad"
                    />
                  </v-col>
                  <v-col v-if="got_feature('feature_actividad_selector') && (hasActivityPermissionUser)" cols="6" sm="4" md="2">
                    <v-autocomplete
                      label="Actividad"
                      v-model="default_activity"
                      :items="activities"
                      :class="{'invalid':screen_data.empty_actividad, 'mx-2':true}"
                      item-value="code" item-text="name"
                      :clearable="true"
                    />
                  </v-col>
                  <v-col
                    v-if="projects && projects.length>0 && (hasProjectPermissionStandarUser)"
                    cols="6"
                    sm="4"
                    md="2"
                  >
                    <v-autocomplete 
                      v-model="selected_project" 
                      class="mx-2" 
                      label="Proyecto" 
                      :items="projects" 
                      :clearable="true"  
                      item-text="name" 
                      item-value="id"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-checkbox v-model="split" class="mx-2" label="Separar páginas" />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </app-page-card>

    <v-snackbar
        v-model="screen_data.snackbar.isVisible"
        :color="screen_data.snackbar.color"
        :timeout="screen_data.snackbar.timeout"
    >
        {{ screen_data.snackbar.text }}
    </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppAutocomplete from '@/components/layout/AppAutocomplete.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import AppBtn from '@/components/layout/AppBtn.vue';
import AppHeaderWithSubtitle from '@/components/layout/AppHeaderWithSubtitle.vue';
import AppPageCard from '@/components/layout/AppPageCard.vue';
import AppSelect from '@/components/layout/AppSelect.vue';
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue';
import AppConfirmModalTitle from '@/components/layout/AppConfirmModalTitle.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import PhotoLoadingDialog from "@/components/DocumentLoad/PhotoLoadingDialog.vue";
import { client } from "@/api/client";
import { notarnet } from '@/api/notarnet'
import { mapGetters, mapState, mapActions } from "vuex"
import { mapFields } from 'vuex-map-fields';
import { Storage, Auth} from "aws-amplify";
import { v4 as uuidv4 } from 'uuid';
import { isValidDate } from '../utils'
import { ACCOUNTING_DATE_OPTIONS,REGISTRO_DATE_OPTIONS } from '../store/constants.js';
import awsconfig from '../aws-exports';
import { apiDocuments } from "@/api";
import { removeDuplicates, lastFunctionUploadingFiles,setSnackbar} from '../../src/modules/invoices/domain/Invoice.ts'
import {get_upload_config,upload_files_to_s3,get_config_errors} from '../../src/modules/invoices/domain/UploadInvoice.ts'
import { VueFeatureRepository } from "../modules/shared/infra/FeatureRepository"
import { async_command_dispatcher} from "@/api/client";
import { sync_command_dispatcher} from "@/api/client";
import { uploadFiles2 as uploadFiles2Fn } from '@/modules/invoices/app/UploadFiles2.ts';

export default {
  components: {
    AppAutocomplete,
    AppBtn,
    AppConfirmModal,
    AppConfirmModalTitle,
    AppModalContainer,
    AppModalRow,
    AppModalCol,
    AppHeaderWithSubtitle,
    AppModalPrompt,
    AppPageCard,
    AppSelect,
    AppTextField,
    AppRow,
    AppCol,
    PhotoLoadingDialog
  },

  data() {
    let screen_data = {
      kind: undefined,
      limit_batch: 10, 
      accounting_date_config:'invoice_date',
      default_accounting_date:'',
      registro_date_config:'today',
      default_registro_date:'',

      empty_kind: false,
      empty_actividad: false, 
      invalid_default_accounting_date: false, 
      invalid_default_registro_date: false,
      files: null, 
      uploaded_files: {}, 
      uploading: false, 
      uploading_percent: 0, 
      invalid_ext: [],
      excel_kind: 'excel_list',
      uploading_file: '',
      snackbar: {
        isVisible: false,
        text: '',
        color: '',
        timeout: 2000,
      },
      confirm_title: "Los siguientes ficheros no se han subido correctamente",
      error_dialog: false,
      error_uploading: false,
      dialog_err_txt: '',
      error_dialog_ext: false,
      general_error_dialog: false,
      general_error_text: '',
    }
    return {
      screen_data: screen_data,
      s3: undefined,
      creds: undefined,

      ACCOUNTING_DATE_OPTIONS,
      REGISTRO_DATE_OPTIONS,
      panel: [0],
      company: null,
      valid: null,
      split: false,
      certificate:false,
      selected_tags: [],
      selected_contract: null,
      tags: [],
      selected_project: null,
      selected_section: null,
      selected_delegation: null,
      selected_department: null,
      dragging_file: false,
      uploading_percent2: 0,
      photoDialog: false,
      documentBatch: {},
      photoCapture: null,
      old_company: null
    };
  },

  watch :{
    selected_activity(value, oldValue) {
      if (value != oldValue && this.currentCompany) {
        this.currentCompany.configuration.actividad = value;
      }
    },
    currentCompany(newValue) {
      if (newValue && newValue.id && newValue.id !== this.old_company) {
        this.old_company = newValue.id;
        this.selected_project = null
        this.selected_section = null
        this.selected_delegation = null
        this.selected_department = null
        // this.default_channel = null
        // this.default_activity = null
      }
    }
  },

  computed:{
    ...mapFields(['projects', 'channels', 'activities', 'default_activity', 'sections', 'delegations', 'departments', 'default_channel']),
    ...mapState(['currentCompany', 'session_information']),
    ...mapGetters({
        me: 'me/me',
        userData: 'me/userData',
        availableDocs: 'me/availableDocs',
        is_mobile: 'is_mobile',
        permission: 'permissions/permission',
        got_feature: 'got_feature',
        get_delegations: 'get_delegations'
      }),

    showCertificate(){
      return this.got_feature('feature_can_upload_certificado')
    },
    change_company () {
      if (this.old_company !== this.currentCompany.id){
        this.old_company = this.currentCompany.id
        this.selected_project = null
      }
      return this.selected_project;
    },
    squareHeight(){
      if(this.showCertificate){
        return undefined
      }
      else{
        return 0
      }
    },
    main_tab_text(){
      if(!this.showCertificate){
        return ''
      }
      else{
        return 'Subida Clásica'
      }
    },
    hasActivityPermissionUser(){
      return this.hasMasterPermission('actividad') && !this.currentCompany.hide_activities_master;
    },
    hasActivityStrPermissionUser(){
      return this.hasMasterPermission('actividad_str') && !this.currentCompany.hide_activities_master;
    },
    hasProjectPermissionUser(){
      return this.got_feature('feature_document_projects') && this.hasMasterPermission('project') && !this.currentCompany.hide_projects_master;
    },
    hasChannelPermissionUser() {
      return this.got_feature('feature_channel') && this.hasMasterPermission('channel') && !this.currentCompany.hide_channels_master
    },
    hasSectionPermissionUser(){
      return this.got_feature('feature_sections') && this.hasMasterPermission('section') && !this.currentCompany.hide_sections_master;
    },
    hasDelegationPermissionUser(){
      return this.got_feature('feature_delegations') && this.hasMasterPermission('delegation') && !this.currentCompany.hide_delegations_master;
    },
    hasDepartmentPermissionUser(){
      return this.got_feature('feature_departments') && this.hasMasterPermission('department') && !this.currentCompany.hide_departments_master;
    },
    excelFileChosen(){
      let excel_in_files = false
      for (let i in this.screen_data.files) {
        let fname = this.screen_data.files[i].name.toLowerCase()
        if (fname.endsWith('.xls') || fname.endsWith('.xlsm') || fname.endsWith('.ods') || fname.endsWith('.xlsx')){
          excel_in_files =true
        }
      }
      return this.userData.available_features['feature_upload_excel'] && this.screen_data.files && this.screen_data.files.length && excel_in_files;
    },
    wrongFormatMsg() {
      return `Los formatos soportados son: ${this.userData.available_features['feature_upload_excel'] && 'xls, xlsx, xlsm, ods, '}jpg, jpeg, png, zip, pdf, tif, 7z y rar.`
    },
    hasProjectPermissionStandarUser(){
      return this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.show && this.currentCompany.companydb_type.params.show.includes('project')
    },
    certifiedInvoiceFormIsValid() {
      return this.screen_data.kind && this.photoCapture
    },
  },
  methods:{
    ...mapActions({
      waitForLoggedIn: "waitForLoggedIn",
      refreshUserData: "me/refreshUserData",
      setDelegations: "setDelegations",
      setProjects: "setProjects"
      }),
    dropFiles(e){  
      if (this.screen_data.files == null) {
        this.screen_data.files = Array();
      }
      let new_files = Array.from(e.dataTransfer.files);
      var duplicated_file = false;
      var empty_file = false;
      new_files.forEach((item_new_file) => {
        if (item_new_file.size == 0) {
          empty_file = true;
        }
        else if (!(this.screen_data.files.some((item_file) => item_file.name === item_new_file.name && item_file.size === item_new_file.size))) {
          this.screen_data.files.push(item_new_file);
        }
        else {
          duplicated_file = true;
        }          
      });
      if (empty_file) {
        alert("Alguno de los archivos tiene tamaño 0. Comprueba que no estas arrastrando los archivos directamente desde dentro de un archivo comprimido.");
      }
      if (duplicated_file) {
        alert("Los archivos duplicados solo se subirán una vez");
      }
      if (!this.got_feature('feature_limit_files_upload')) {
        if (this.screen_data.files.length > this.screen_data.limit_batch) {
          alert("Solo se permiten subir " + this.screen_data.limit_batch + " ficheros a la vez. Si quieres subir más archivos de una sola vez, utiliza un archivo comprimido zip/rar/7z que contenga múltiples archivos.");
          this.screen_data.files = this.screen_data.files.slice(0, this.screen_data.limit_batch);
        }
      }   
      this.dragging_file = false;
      e.preventDefault();
    },

    async removeDuplicates() {
      let feature_repo = new VueFeatureRepository(this.got_feature)
      removeDuplicates(this.screen_data, feature_repo, alert);
    },

    hasMasterPermission(master) {
      return this.currentCompany && this.currentCompany.configuration && this.currentCompany.companydb_type && this.currentCompany.companydb_type.params 
      && this.currentCompany.companydb_type.params.show && this.currentCompany.companydb_type.params.show.includes(master);
    },

    date_to_string(d){
      var mm = d.getMonth() + 1; // getMonth() is zero-based
      var dd = d.getDate();

      return [(dd>9 ? '' : '0') + dd,
          (mm>9 ? '' : '0') + mm,
          d.getFullYear()
         ].join('/');
    },
    async createDocumentBatch(filesData, upload_config=null) {
      let companyDBId = this.currentCompany.id;
      let userId = this.userData.id;
      let response = await apiDocuments.createDocumentBatch(companyDBId, userId, JSON.stringify(filesData), JSON.stringify(upload_config));
      this.documentBatch = response.data;
      return response;
    },
    async uploadFiles() {
      if (this.got_feature('feature_new_upload_documents')){
        this.uploadFiles2()
        return
      }
      let feature_repo = new VueFeatureRepository(this.got_feature)
      await lastFunctionUploadingFiles(this.screen_data, feature_repo, this.currentCompany, Auth.currentCredentials, this.userData, uuidv4, this.processFile, this.createDocumentBatch, this.default_activity)
      
    },

    async uploadFiles2() {
      await uploadFiles2Fn(
        this.screen_data,
        new VueFeatureRepository(this.got_feature),
        alert,
        Auth,
        this.createDocumentBatch.bind(this),
        sync_command_dispatcher,
        this
      );
    },
    retryUploadFiles() {
      this.screen_data.uploading = true;
      let retry_files = []
      for (let i in this.screen_data.files) {
        if (!this.screen_data.uploaded_files[this.screen_data.files[i].name]) {
          retry_files.push(this.screen_data.files[i])
        }
      }
      this.screen_data.files = retry_files;
      this.uploadFiles();
    },
    isValidExtension(ext){
      let valid_ext = ['pdf','jpg','jpeg','png','zip','rar','7z','tiff']
      if(this.userData.available_features['feature_upload_excel']){
        valid_ext = valid_ext.concat(['xls', 'xlsx', 'xlsm', 'ods'])
        valid_ext = valid_ext.concat(['xml','xsig'])
      }
      if(this.userData.available_features['feature_upload_office']){
        valid_ext = valid_ext.concat(['docx', 'doc', 'odt'])
      }
      return valid_ext.includes(ext.toLowerCase())
    },
    upload_file_to_s3(file_name, file, index) {
      let that = this;
      return this.s3.upload({   
        Bucket: awsconfig['aws_user_files_s3_bucket'],     
        Key: file_name,
        Body: file,
        ACL: 'private',
        contentType: 'application/pdf',
        CacheControl: 'max-age=0, public'
      }).on('httpUploadProgress', function(evt) {
        that.uploading_percent2 = evt.loaded * 100 / evt.total;
      }).promise()
    },
    async processFile(file, uuid, extension, identityId, index) {
      let aux = undefined;
      const file_name = `private/${identityId}/pdfs/${uuid}.${extension}`
      this.uploading_percent2 = 0;
      try {
        aux = await this.upload_file_to_s3(file_name, file, index)
      } catch {
        this.setS3Params();
        aux = await this.upload_file_to_s3(file_name, file, index);
      }
      const formData = new FormData();
      formData.append('original_file_name', file.name)
      formData.append('uuid_file', uuid)
      formData.append('extension', extension)
      formData.append('identity_id', identityId)
      formData.append('accounting_date_config',this.screen_data.accounting_date_config)
      formData.append('default_accounting_date',this.screen_data.default_accounting_date)
      formData.append('companydb', this.currentCompany.id)
      formData.append('kind', this.screen_data.kind)
      formData.append('certificate', this.certificate)
      if (this.excelFileChosen){
        formData.append('excel_kind', this.screen_data.excel_kind)
      }
      if (this.documentBatch.id) {
        formData.append('document_batch', this.documentBatch.id);
      }
      if (this.got_feature('feature_fecha_registro') && this.currentCompany && this.currentCompany.enable_fecha_sii){
        formData.append('registro_date_config',this.screen_data.registro_date_config)
        formData.append('default_registro_date',this.screen_data.default_registro_date)
      }


    //   if (this.currentCompany && this.currentCompany.configuration && this.currentCompany.companydb_type && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.show && this.currentCompany.companydb_type.params.show.includes('actividad') && this.currentCompany.configuration.actividad) {
    //     formData.append('actividad', this.currentCompany.configuration.actividad)
    //   }

    
      if (this.selected_project) {
        formData.append('project', this.selected_project)
      }
      if (this.default_channel) {
        formData.append('channel', this.default_channel);
      }
      if (this.selected_section) {
        formData.append('section', this.selected_section)
      }
      if (this.selected_delegation) {
        formData.append('delegation', this.selected_delegation)
      }
      if (this.selected_department) {
        formData.append('department', this.selected_department)
      }
      if (this.default_activity) {
        if (this.hasActivityStrPermissionUser)
          formData.append('actividad_str', this.default_activity)
        else
          formData.append('actividad', this.default_activity)
      }
      if (this.selected_tags.length) {
        formData.append('tags', this.selected_tags)
      }
      if (this.split) {
        formData.append('split', true)
      }

      try {
        let response = await client.post('documents/', formData);
      } catch(e) {
        console.debug(e);
        throw(e)
      }
    },
    saveEndpoint() {

    },
    getTags() {
      let that = this;
      client.get("tags/?limit=100").then(response => {
        that.tags = response.data.results;
      });
    },
    userLoggedIn(providerName, token) {
      this.creds.params.Logins = this.creds.params.Logins || {};
      this.creds.params.Logins[providerName] = token;
      this.creds.expired = true;
    },
    async setS3Params() {
      await this.waitForLoggedIn();
      this.creds = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: awsconfig['aws_cognito_identity_pool_id']
      });
      this.userLoggedIn('cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id'], this.session_information.signInUserSession.idToken.jwtToken)
      AWS.config.update({
        region: awsconfig['aws_user_files_s3_bucket_region'],
        credentials: this.creds,
      });
      this.s3 = new AWS.S3({
        apiVersion: "2006-03-01",
        params: { Bucket: awsconfig['aws_user_files_s3_bucket'] }
      });
    },
    openPhotoDialog() {
      this.photoDialog = true
    },

    closePhotoDialog() {
      this.photoDialog = false
    },

    setPhotoForCertifiedInvoice(photo) {
      this.photoCapture = photo
      this.closePhotoDialog()
    },

    certificateUpload() {
      this.screen_data.files = [this.photoCapture]
      this.certificate=true
      this.uploadFiles()
    //   notarnet.signDocument(this.photoCapture)
    //     .then(res => { console.log(res) })
    //     .catch(err => { console.log(err) })
      },
  },

  async mounted() {
    //els deixo comentats perquè és algo que ja fa resetCurrentCompany que és crida sempre que accedeixes a la empresa
    // if (this.currentCompany && this.currentCompany.id) {
    //   this.$store.dispatch('setSections', this.currentCompany.id)
    //   this.setProjects(this.currentCompany.id)
    //   this.$store.dispatch('setDepartments', this.currentCompany.id)
    //   this.setDelegations(this.currentCompany.id)
    // }
  },
  
  async created() {
    this.setS3Params();
    this.getTags();

    // await this.refreshUserData()
    // console.log(this.userData)
    // this.selected_activity = this.currentCompany.configuration.actividad

    // if (this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.show && this.currentCompany.companydb_type.params.show.includes('actividad')) {
    //   this.selected_activity = this.currentCompany.configuration.actividad
    // }
  }
};
</script>

<style>
.invalid .v-select__slot {
  background-color: red
}
.invalid .v-text-field__slot {
  background-color: red
}
.title-color {
  color:var(--v-primary-base);
}

.dragging_file{
  background: var(--v-neutralDark-base)!important;
  border-radius: 5px;
  border: 2px dashed #ccc;
}

.primary-bckground {
  background-color: var(--v-primary-base);
}
.primary-border {
  border-color: var(--v-primary-base) !important;
}

.file-input--outlined.v-text-field--outlined:not(.error--text) fieldset {
  border-color: var(--v-primary-base);
}

.file-input--outlined > .v-input__control > .v-input__slot {
  -webkit-box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
  box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
}

.document-loader__list-element {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
</style>
